export default [
  {
    name: 'My Company',
    icon: 'fa fa-home',
    path: '/admin/overview',
    package: ['premium'],
    section: 'user'
  }, {
    name: 'My Queries',
    icon: 'fa fa-street-view',
    path: '/queries',
    package: ['basic', 'advanced', 'premium'],
    section: 'user'
  }, {
    name: 'My Team',
    icon: 'fa fa-chart-bar',
    path: '/team',
    package: ['basic', 'advanced', 'premium'],
    section: 'user'
  }, {
    name: 'Waveline',
    icon: 'fa fa-hands-helping',
    path: '/waveline',
    package: ['advanced', 'premium'],
    section: 'user'
  }, {
    name: 'My Tasks',
    icon: 'fa fa-tasks',
    path: '/admin/tasks',
    package: ['advanced', 'premium'],
    section: 'user'
  }, {
    name: 'News',
    icon: 'fa fa-newspaper',
    path: '/admin/news',
    package: ['premium'],
    section: 'user'
  }, {
    name: 'Users',
    icon: 'fa fa-user',
    path: '/admin/users',
    roles: ['admin'],
    package: ['basic', 'advanced', 'premium'],
    section: 'admin'
  }, {
    name: 'Teams',
    icon: 'fa fa-users',
    path: '/admin/teams',
    roles: ['admin'],
    package: ['basic', 'advanced', 'premium'],
    section: 'admin'
  }, {
    name: 'Questionnaires',
    icon: 'fa fa-question',
    path: '/admin/questionnaires',
    roles: ['admin'],
    package: ['basic', 'advanced', 'premium'],
    section: 'admin'
  }, {
    name: 'Settings',
    icon: 'fa fa-cog',
    path: '/admin/settings',
    roles: ['admin'],
    package: ['basic', 'advanced', 'premium'],
    section: 'admin'
  }, {
    name: 'Info',
    icon: 'fa fa-info',
    path: '/info',
    package: ['basic', 'advanced', 'premium'],
    section: 'user'
  }
]
